function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.175 0.279C3.26564 0.201269 3.3811 0.158539 3.5005 0.158539C3.6199 0.158539 3.73536 0.201269 3.826 0.279L5.974 2.12C6.05175 2.18649 6.10723 2.27522 6.13296 2.37423C6.1587 2.47324 6.15344 2.57776 6.1179 2.67369C6.08236 2.76962 6.01826 2.85234 5.93423 2.91069C5.8502 2.96904 5.7503 3.00021 5.648 3H1.348C1.24579 3.00001 1.14602 2.96869 1.06216 2.91026C0.978286 2.85184 0.914338 2.76911 0.878927 2.67322C0.843515 2.57734 0.83834 2.47291 0.8641 2.37399C0.88986 2.27508 0.945317 2.18643 1.023 2.12L3.175 0.279Z",
  fill: "currentColor"
});

var SvgSortArrow = function SvgSortArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 3,
    viewBox: "0 0 7 3",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSortArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sortArrow.fa5ee778.svg";
export { ForwardRef as ReactComponent };